import { render, staticRenderFns } from "./codeButton.vue?vue&type=template&id=0fa18d91&"
import script from "./codeButton.vue?vue&type=script&lang=ts&"
export * from "./codeButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports